import {
    // ANALYTICS
    ANALYZE_MENTIONS,
    ANALYZE_OVERVIEW,
    ANALYZE_PERFORMANCE,
    ANALYZE_REACH_IMPRESSIONS,
    // PUBLISHING
    SCHEDULER,
    // LISTENING
    LISTENING_HASHTAG,
    LISTENING_HASHTAGS,
    LISTENING_FEED,
    LISTENING_FEEDS,
    LISTENING_COMPETITOR,
    LISTENING_COMPETITORS,
    MANAGE_COMMENTS_TRACKER,
    MANAGE_MENTIONS_TRACKER
} from '@/lib/routes/privateRoutes';
import { INSTAGRAM, FACEBOOK, LINKEDIN, TIKTOK_BUSINESS, TWITTER } from '@/lib/socialProfile';

/**
 * Add pages so that content is displayed when the user selects a group instead of the empty state
 */
export const groupHasAccess = [ANALYZE_OVERVIEW, SCHEDULER];

/**
 * If the page is not specified in networkHasAccess, all networks will have access to the page.
 */
export const networkHasAccess = {
    [ANALYZE_PERFORMANCE]: [INSTAGRAM, FACEBOOK],
    [ANALYZE_REACH_IMPRESSIONS]: [INSTAGRAM, FACEBOOK, LINKEDIN, TWITTER],
    [ANALYZE_MENTIONS]: [INSTAGRAM],
    [LISTENING_HASHTAG]: [INSTAGRAM],
    [LISTENING_HASHTAGS]: [INSTAGRAM],
    [LISTENING_FEED]: [INSTAGRAM, FACEBOOK],
    [LISTENING_FEEDS]: [INSTAGRAM, FACEBOOK],
    [LISTENING_COMPETITOR]: [INSTAGRAM, FACEBOOK],
    [LISTENING_COMPETITORS]: [INSTAGRAM, FACEBOOK],
    [MANAGE_COMMENTS_TRACKER]: [INSTAGRAM, FACEBOOK, LINKEDIN, TIKTOK_BUSINESS],
    [MANAGE_MENTIONS_TRACKER]: [INSTAGRAM]
} as const;
